var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{ref:"iconElement",class:_vm.evaluateClassForItem,on:{"click":function($event){return _vm.action_SelectReservation()},"dblclick":_vm.action_DoubleClick,"mouseover":function($event){return _vm.action_ReservationMouseOver()},"mouseout":function($event){return _vm.action_ReservationMouseOut()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }